import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c82b2b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "consent_content"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" เว็บไซต์นี้มีการจัดเก็บคุกกี้เพื่อมอบประสบการณ์การใช้งานเว็บไซต์ของคุณให้ดียิ่งขึ้น ท่านสามารถศึกษานโยบายการเก็บและใช้ ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" และ ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ได้ที่ลิงค์นี้ การใช้งานเว็บไซต์นี้เป็นการยอมรับข้อกำหนดและยินยอมให้เราจัดเก็บคุ้กกี้ตามนโยบายที่แจ้งในเบื้องต้น ")
const _hoisted_5 = { class: "bt_login" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ยอมรับเงื่อนไข ")
const _hoisted_8 = {
  key: 0,
  class: "confirm-consent-txt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.IsShowConsent)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ConsentContain",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleIsConsent(false)), ["prevent"]))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["ConsentCampaign", { f30: !_ctx.IsShowConsent }])
        }, [
          (_ctx.IsShowConsent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["consent_detail", { warn: _ctx.IsError }])
                  }, [
                    _hoisted_2,
                    _createElementVNode("span", {
                      class: "under_line",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ShowPopupCookie && _ctx.ShowPopupCookie(...args)), ["prevent"]))
                    }, "คุกกี้"),
                    _hoisted_3,
                    _createElementVNode("span", {
                      class: "under_line",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ShowPopupCookie && _ctx.ShowPopupCookie(...args)), ["prevent"]))
                    }, "ข้อกำหนด"),
                    _hoisted_4
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["bt", {'active':_ctx.checked}]),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleConsentConfirm(true)), ["prevent"]))
            }, [
              _createElementVNode("img", {
                src: `${require('@/assets/images/home/check.svg')}`
              }, null, 8, _hoisted_6),
              _hoisted_7
            ], 2),
            (!_ctx.confirmConsent && !_ctx.checked)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " กรุณากดยอมรับเงื่อนไข "))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}